import { Money as MoneyType } from '__generated__/types';
import {
  getCurrencySymbolByCode,
  getFormattedMoneyFabric,
  getMoneyFabric,
  getXMoneyFabric,
  IXMoney,
} from '@xometry/money';
import { ReactComponent as IconEU } from 'assets/images/icon-eu.min.svg';
import { ReactComponent as IconTR } from 'assets/images/icon-tr.min.svg';
import { ReactComponent as IconUK } from 'assets/images/icon-uk.min.svg';
import { ReactComponent as IconUS } from 'assets/images/icon-us.min.svg';
import { getRegionCurrency, getRegionCurrencySymbol } from 'config/regions/utils';
import { FunctionComponent, SVGProps } from 'react';

const CurrencyFlagIconByCurrency: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  TRY: IconTR,
  GBP: IconUK,
  EUR: IconEU,
  USD: IconUS,
};

export const getCurrencySymbol = (code?: string | null) => {
  const FALLBACK = getRegionCurrencySymbol();

  return getCurrencySymbolByCode(code, FALLBACK);
};

/**
 * Component for money values.
 * Outputs it according to currency rules.
 */
const MoneyComponent = getMoneyFabric({ fallbackCurrencyCode: getRegionCurrency() });
export const Money = MoneyComponent;

/**
 * Class for math operations with money.
 */
export const XMoney = getXMoneyFabric({ fallbackCurrencyCode: getRegionCurrency() });
/**
 * Plan utility to format money values, according to currency rules.
 * Note: use it only when Money component isn't suitable.
 */
export const formatMoney = getFormattedMoneyFabric({ fallbackCurrencyCode: getRegionCurrency() });

export const getCurrencyFlagIconByCurrency = (
  currencyCode: string,
): FunctionComponent<SVGProps<SVGSVGElement>> | undefined => CurrencyFlagIconByCurrency[currencyCode];

export const toIMoney = (value: IXMoney | null | undefined) => {
  if (!value) {
    return null;
  }

  return value.toIMoney() as MoneyType;
};
